import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatUtilityGetTypesService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_TYPE_RESPONSE_DATA, 'chatUtilityGetTypesStatus');
  }

  handleEvent(eventName, event) {
    return this.getClient('evergreen').post(`/auditlog/getTypes`, event.payload);
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('chatUtilityGetTypes').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        // TODO: This will be uncommented once Type API will be developed...
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
        // Framework.getStoreRegistry().getStore('chatUtilityGetTypes').triggerEvent();
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
